import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

// const getApiCall = async (ApiEndPoint, id) => {
//   const token = "Bearer " + localStorage.getItem("ApiToken");
//   try {
//     if (id) {
//       const resp = await axios.get(`${API_URL}/${ApiEndPoint}/${id}`, {
//         headers: { Authorization: token },
//       });
//       const axiosRespHandle = resp.data.data;
//       return axiosRespHandle;
//     } else {
//       const resp = await axios.get(`${API_URL}/${ApiEndPoint}`, {
//         headers: { Authorization: token },
//       });
//       const axiosRespHandle = resp.data.data;
//       return axiosRespHandle;
//     }
//   } catch (error) {
//       console.log(error.response.data.code);
//     throw error;
//     // console.log("SSSS", axios.isAxiosError(error));

//     // if (axios.isAxiosError(error)) {
//     //   console.log("dsa22222222dasd");

//     //   console.log("dsadasd", handleAxiosError(error));
//     //   handleAxiosError(error);
//     // } else {
//     //   handleUnexpectedError(error);
//     //   console.log("gggggggggg");
//     // }
//   }
// };

const getApiCall = async (ApiEndPoint, id = null) => {
  const token = "Bearer " + localStorage.getItem("ApiToken");
  const config = {
    headers: { Authorization: token },
  };

  try {
    const url = id ? `${API_URL}/${ApiEndPoint}/${id}` : `${API_URL}/${ApiEndPoint}`;
    const response = await axios.get(url, config);
    return response.data.data;
  } catch (error) {
    if (error.response) {
      // Server responded with a status other than 2xx
      console.error("API Error:", error.response.data);
    } else if (error.request) {
      // Request was made but no response was received
      console.error("Network Error:", error.request);
    } else {
      // Something else happened while setting up the request
      console.error("Error:", error.message);
    }
    // Optionally, you can return a default value or handle the error as needed
    return null;
  }
};


export default getApiCall;
